import { css } from "lit";

export const premiumContentControlsStyles = css`
  :host {
    display: flex;
    flex-direction: column;
    gap: var(--spacing-4, 1rem);
    box-sizing: border-box;
  }

  .section {
    display: flex;
    flex-direction: column;
    gap: var(--spacing-3, 0.75rem);
    padding: var(--spacing-3, 0.75rem);
    border: 1px solid var(--color-border-secondary, #e0e0e0);
    border-radius: var(--radius-2, 8px);
    background: var(--color-background-secondary, #f9f9f9);
  }

  .tier-creation-notice {
    display: flex;
    flex-direction: column;
    gap: var(--spacing-2, 0.5rem);
    padding: var(--spacing-3, 0.75rem);
    background: var(--color-info-light, #e3f2fd);
    border: 1px solid var(--color-info, #2196f3);
    border-radius: var(--radius-1, 4px);
    margin-top: var(--spacing-2, 0.5rem);
  }

  .notice-text {
    margin: 0;
    font-size: var(--font-size-sm, 0.875rem);
    color: var(--color-text-secondary, #666);
    line-height: 1.5;
  }

  .tier-info {
    display: flex;
    align-items: center;
    gap: var(--spacing-2, 0.5rem);
    padding: var(--spacing-2, 0.5rem);
    background: var(--color-background-tertiary, #f0f0f0);
    border-radius: var(--radius-1, 4px);
    font-size: var(--font-size-sm, 0.875rem);
  }

  .tier-info-label {
    color: var(--color-text-secondary, #666);
  }

  .tier-info-value {
    font-weight: var(--font-weight-semibold, 600);
    color: var(--color-primary, #007bff);
  }

  wow-switch {
    --switch-width: 48px;
    --switch-height: 24px;
  }

  wow-input {
    margin-top: var(--spacing-2, 0.5rem);
  }
`;
